<template>
  <section class="story-detail">
    <div class="banner">
      <div class="left flex container-main">
        <div class="left-body card-border-box">
          <div class="title">{{ detailData.name }}</div>
          <div class="desc" v-html="decodeURIComponent(detailData.intro)"></div>
        </div>
      </div>
      <div class="img-box">
        <img :src="detailData.infoUrl" width="1920" height="700" />
      </div>
    </div>
    <div v-for="item in detailCon" :key="item.id">
      <div class="short-list-item" v-if="item.contentType == 'intro'">
        <div class="short-main author-box flex">
          <div class="left">
            <img src="@/assets/story/story-detail-avator.svg" />
          </div>
          <div class="right">
            <div class="fy" v-html="decodeURIComponent(item.content)">
            </div>
            <div>
              <p class="author">{{ item.author }}</p>
              <p>{{ item.position }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 卡片 -->
      <div
        class="short-list-item"
        v-if="item.contentType == 'card'"
      >
       <div class="card-border-box scheme-intro cardCon">
        <p v-html="decodeURIComponent(item.content)"></p>
       </div>
      </div>
      <div class="short-list-item" v-if="item.contentType == 'richtext' || item.contentType == 'video' ">
        <div class="short-main scheme-desc">
          <h3 v-if="item.title" v-html="decodeURIComponent(item.title)"></h3>
                <!-- 视频内容特殊处理 -->
          <div class="content-wrapper" v-if="item.contentType == 'video'">
            <div class="video-container" v-html="processVideoContent(item.content)"></div>
          </div>
         
          <!-- 富文本内容 -->
          <p v-if="item.contentType == 'richtext'" v-html="safeDecode(item.content)"></p>
        </div>
      </div>
      <!-- 图片类型 -->
      <div class="short-list-item" v-if="item.contentType == 'image'">
        <div class="short-main scheme-desc">
          <h3 v-if="item.title" v-html="decodeURIComponent(item.title)"></h3>
          <div
            class="image-con"
            v-html="processContent(item.content)"
          ></div>
        </div>
      </div>
      <!-- 链接 -->
      <div class="short-list-item linkCon" v-if="item.contentType == 'link'">
        <div class="short-main scheme-desc">
          <div class="link-con">
            <div
              class="link-words"
              v-if="item.title"
              v-html="decodeURIComponent(item.title)"
            ></div>
            <div class="link-href">
              <a class="link-a" :href="extractUrlFromContent(item.content)" target="blank" rel="noopener noreferrer">去看看</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import request from '../../utils/request'
export default {
  name: 'Platform',
  components: {},
  data() {
    return {
      id: '',
      detailData: {},
      detailCon: []
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.getCaseDetail()
    console.log('id', this.id)
  },
  methods: {
      // 从内容中提取URL
  extractUrlFromContent(content) {
    try {
      // 1. 先解码URI
      const decoded = decodeURIComponent(content || '');
      
      // 2. 提取URL（匹配http/https链接）
      const urlMatch = decoded.match(/https?:\/\/[^\s"'<>]+/i);
      const rawUrl = urlMatch ? urlMatch[0] : '';
      
      // 3. 清理可能的HTML标签残留
      return rawUrl.replace(/<\/?[^>]+(>|$)/g, '');
    } catch(e) {
      return '#'; // 失败时返回安全值
    }
  },
     // 安全解码
  safeDecode(str) {
    try {
      return decodeURIComponent(str || '')
    } catch(e) {
      return str || ''
    }
  },
   // 专门处理视频内容
  processVideoContent(content) {
    try {
      const decoded = decodeURIComponent(content || '')
      // 给iframe添加响应式样式
      return decoded.replace(/<iframe/g, '<iframe style="width:100%;height:auto;min-height:400px;border:none" allowfullscreen')
    } catch(e) {
      return content || ''
    }
  },
    processContent(content) {
    try {
      const decoded = decodeURIComponent(content);
      // 给所有图片添加样式
      return decoded.replace(/<img/g, '<img style="width:100% !important;height:auto !important;margin-top:10px;"');
    } catch(e) {
      return content;
    }
  },
    getCaseDetail() {
      request({
        url: `/cases/getInfo/${this.id}`,
        params: {},
        data: {},
        method: 'post'
      }).then(res => {
        console.log('res', res)
        this.detailData = res.data
        this.detailCon = res.data.casesInfoList
      })
    }
  }
}
</script>

<style scoped lang="less">
.banner {
  height: 500px;
  position: relative;
  display: flex;
  align-items: center;
  .left {
    z-index: 1;
    .left-body {
      background: #fff;
      width: 570px;
      min-height: 290px;
      padding-block-start: 50px;
      padding-block-end: 30px;
      padding-inline-start: 65px;
      padding-inline-end: 50px;
      .title {
        font-size: 32px;
        font-weight: bold;
        margin: 10px 0 30px;
      }
      .desc {
        font-size: 26px;
        margin-bottom: 10px;
      }
    }
  }
  .img-box {
    position: absolute;
    top: 0;
    right: 0;
    transition: background 0.3s, border 0.3s, border-radius 0.3s,
      box-shadow 0.3s, transform var(--e-transform-transition-duration, 0.4s);
    text-align: right;
    img {
      width: 70vw;
      height: 500px;
      object-fit: cover;
      object-position: center center;
      vertical-align: middle;
      display: inline-block;
      max-width: 100%;
      border: none;
      border-radius: 0;
      box-shadow: none;
    }
  }
}
.short-list-item {
  background-color: #fff;
  padding: 30px 0;
  padding-bottom: 0;
  /* &:nth-child(2n + 1) {
    background-color: #fbfbfc;
  } */
  .author-box {
    gap: 20px;
    padding-bottom: 20px;
    font-size: 16px;
    .left {
      width: 54px;
      height: 54px;
    }
    .right {
      flex: 1;
      font-size: 20px;
      .fy {
        font-family: 'Poppins', Sans-serif;
        font-weight: 400;
        font-style: italic;
        line-height: 1.3em;
      }
      .author {
        margin-top: 30px;
        color: #f15a2c;
        font-size: 22px;
        margin-bottom: 10px;
      }
    }
  }

  .scheme-intro {
    min-height: 200px;
    padding: 0 30px;
    font-size: 16px;
    width: 640px;
    margin: 0 auto;
    ul {
      list-style: disc;
      font-weight: bold;
      margin-top: 30px;
      padding-left: 10px;
      li {
        padding: 5px 0;
      }
      h4 {
        font-weight: bold;
      }
    }
  }
  
  .scheme-desc {
    .image-con {
      width: 100%;
      ::v-deep .ql-video {
        width: 100%;
      }
    }
    .link-con {
      display: flex;
      .link-words {
        flex: 2;
        font-size: 22px;
        font-weight: bold;
        color: #000;
      }
      .link-href {
        flex: 1;
        width: 170px;
        height: 50px;
        line-height: 50px;
        border-radius: 50px;
        text-align: center;
        background-color: #f15a2c;
        .link-a {
          color: #fff;
          font-weight: bold;
        }
      }
    }
    h3 {
      font-size: 20px;
      padding-bottom: 20px;
    }
    p {
      padding-bottom: 20px;
      line-height: 1.7;
    }
    ul {
      list-style: disc;
      margin-left: 30px;
      li {
        padding: 5px 0;
      }
    }
    h4 {
      margin: 10px 0;
    }
  }
  img {
    max-width: 100%;
  }
}
.cardCon{
    padding: 30px;
    background-color: #fff;
  }
  .linkCon{
    background-color: #fbfbfc;
    padding-bottom: 30px;
  }
</style>
